<div class="single-blog-post">
  <div class="blog-image">
    <a [href]="newsArticle.href.url + '?fm=webp&q=90&h=191'" [target]="'_blank'">
      <img [src]="newsArticle.href.openGraph.image" alt="image" />
    </a>
    <div class="date"><i-feather name="calendar"></i-feather>{{ newsArticle.publishedDate | date: 'mediumDate' }}</div>
  </div>
  <div class="blog-post-content">
    <h3>
      <a [href]="newsArticle.href.url" [target]="'_blank'">{{ newsArticle.href.meta.title | shorten: 70:'...' }}</a>
    </h3>
    <span i18n="@@newsArticleBy"
      >by <a>{{ newsArticle.publisher.name | uppercase }}</a></span
    >
    <p>
      {{ newsArticle.href.meta.description | shorten: 150:'...' }}
    </p>
    <a [href]="newsArticle.href.url" [target]="'_blank'" class="read-more-btn">
      {{ readMore }} <i-feather name="arrow-right"></i-feather
    ></a>
  </div>
</div>
